import gql from "graphql-tag"

const getCase = () => (gql`
{     
    extractCase {
        id
        ready
        createdtime
    }    
}
`)

const getPrivacy = () => (gql`
{     
    contactDetails {
        phoneNumber
    }
    bookings {
        bookingNumber
    }
}
`)

export {
    getCase,
    getPrivacy
}
